<template>
    <div v-if="event_booking" class="row">
        <div class="col col-12">
            <div v-if="event_booking.booking_count > 0" class="summary">
                <div class="card">
                    <div
                        class="card-header hg-underline"
                        :style="underlineOverride"
                    >
                        Thank you for booking your tickets for this Event.
                    </div>
                    <div class="card-body">
                        <div class="card-text">
                            <p>
                                If you wish to make any other changes, please
                                contact your event organiser
                            </p>
                            <p>You can view your booking by clicking below:</p>
                        </div>
                    </div>
                    <div class="card-footer hg-blank-footer">
                        <a
                            :style="{
                                'background-color': event.buttoncolour,
                                'border-color': event.buttoncolour,
                            }"
                            role="button"
                            class="btn btn-secondary"
                            :href="
                                '/invite/' +
                                event_booking.uuid +
                                '/?mode=readonly'
                            "
                            >View/Amend Booking</a
                        >
                        <a
                            :style="{
                                'background-color': event.buttoncolour,
                                'border-color': event.buttoncolour,
                            }"
                            role="button"
                            class="btn btn-secondary"
                            :href="
                                'mailto:' +
                                event.organiser_email +
                                '?Subject=Query%20about%20' +
                                event.title
                            "
                            >Email Organiser</a
                        >
                        <a
                            v-if="orgWebsite"
                            :style="{
                                'background-color': event.buttoncolour,
                                'border-color': event.buttoncolour,
                            }"
                            role="button"
                            class="btn btn-secondary"
                            :href="orgWebsite"
                            >Back</a
                        >
                    </div>
                </div>
                <div class="card">
                    <div
                        class="card-header hg-underline"
                        :style="underlineOverride"
                    >
                        Click below to cancel your event booking
                    </div>
                    <div class="card-body">
                        <div class="card-text">
                            <p>
                                Terms and Conditions will apply to cancellations
                            </p>
                        </div>
                    </div>
                    <div class="card-footer hg-blank-footer">
                        <button
                            type="button"
                            :style="{
                                'background-color': event.buttoncolour,
                                'border-color': event.buttoncolour,
                            }"
                            class="btn btn-secondary"
                            @click="cancelBooking()"
                        >
                            Cancel My Booking
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="event_booking.cancelled_at" class="card">
                <div class="card-header text-center">
                    <h3>This Event Booking Has Been Cancelled</h3>
                </div>
            </div>
        </div>
        <div class="col col-12">
            <div class="card">
                <div
                    class="card-header hg-underline"
                    :style="underlineOverride"
                >
                    Share this event
                </div>
                <div class="card-body">
                    <social-circles :event="event"></social-circles>
                </div>
            </div>
            <div v-if="event.acc_enabled" class="card">
                <div
                    class="card-header hg-underline"
                    :style="underlineOverride"
                >
                    Click below to book accommodation
                </div>
                <div class="card-body">
                    <a
                        :style="{
                            'background-color': event.buttoncolour,
                            'border-color': event.buttoncolour,
                        }"
                        role="button"
                        class="btn btn-secondary"
                        href="https://www.booking.com/index.en-gb.html?aid=1593432"
                        target="_blank"
                        >Book Accommodation</a
                    >
                </div>
            </div>
        </div>
        <div class="col col-12">
            <!-- This has been extracted to page-summary, use that -->
            <div class="card">
                <div
                    class="card-header hg-underline"
                    :style="underlineOverride"
                >
                    Tickets Booked
                </div>
                <div class="card-body">
                    <table class="table table-tickets">
                        <thead class="thead-light">
                            <th v-if="event.ticket_groups">Group Name</th>
                            <th>Ticket Name</th>
                            <th v-if="hasPaidTickets">
                                Ticket Cost {{ showVatInTitle }}
                            </th>
                            <th
                                v-if="
                                    hasPaidTickets &&
                                    event.show_vat &&
                                    event.vat_exclusive
                                "
                            >
                                Ticket VAT Amount
                            </th>
                            <th>No of Tickets</th>
                            <th>Date & Time</th>
                            <th></th>
                        </thead>
                        <tfoot v-if="hasPaidTickets">
                            <td
                                class="bsactualcoast hide-cell"
                                :style="actualCostBG"
                            ></td>
                            <td
                                class="bsactualcoast hide-cell"
                                :style="actualCostBG"
                            >
                                TICKET TOTAL
                            </td>
                            <td
                                data-label="TICKET TOTAL"
                                class="bsactualcoast"
                                :style="actualCostBG"
                            >
                                {{
                                    totalCost(tickets, discountValid, true)
                                        | currency('£')
                                }}
                            </td>
                            <td
                                data-label="VAT TOTAL"
                                class="bsactualcoast"
                                :style="actualCostBG"
                                v-if="event.vat_exclusive"
                            >
                                {{
                                    (totalVatExc(tickets, discountValid, true) *
                                        100)
                                        | currency('£')
                                }}
                            </td>
                            <td
                                class="bsactualcoast hide-cell"
                                :style="actualCostBG"
                            ></td>
                            <td
                                class="bsactualcoast hide-cell"
                                :style="actualCostBG"
                            ></td>
                            <td
                                class="bsactualcoast hide-cell"
                                :style="actualCostBG"
                            ></td>
                        </tfoot>
                        <tbody>
                            <template v-for="ticket in orderBy(tickets, 'id')">
                                <tr
                                    style="background-color: #f4f6f6"
                                    v-if="
                                        event.ticket_groups &&
                                        ticketHeaderName(ticket) != null
                                    "
                                >
                                    <td :colspan="hasPaidTickets ? '6' : '3'">
                                        <strong
                                            style="
                                                color: #000;
                                                font-weight: bold;
                                            "
                                            >&nbsp;
                                            {{ ticketHeaderName(ticket) }}
                                        </strong>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="hide-cell">
                                        <span
                                            v-if="!ticket.child_ticket"
                                            class="
                                                fa fa-circle
                                                align-right
                                                icon-styling
                                            "
                                            :style="iconColor"
                                        ></span>
                                        <span
                                            v-if="ticket.child_ticket"
                                            class="
                                                fa fa-chevron-right
                                                align-right
                                                icon-styling
                                            "
                                            :style="iconColor"
                                        ></span>
                                    </td>
                                    <td
                                        data-label="Ticket name"
                                        id="bsticketname"
                                    >
                                        {{ ticket.details }}
                                    </td>
                                    <td
                                        data-label="Ticket cost (inc vat)"
                                        id="bsticketcost"
                                        v-if="hasPaidTickets"
                                    >
                                        {{
                                            ticketCost(
                                                ticket,
                                                discountValid,
                                                true
                                            ) | currency('£')
                                        }}
                                        <small>{{
                                            discountTicketText(ticket)
                                        }}</small>
                                    </td>
                                    <td
                                        data-label="Ticket VAT Amount"
                                        v-if="
                                            hasPaidTickets &&
                                            event.vat_exclusive
                                        "
                                    >
                                        {{
                                            ticketVatExc(
                                                ticket,
                                                discountValid,
                                                true
                                            ) | currency('£')
                                        }}
                                    </td>
                                    <td
                                        data-label="Number of tickets"
                                        id="bsnumberoftickets"
                                    >
                                        {{ ticket.quantity_tickets }}
                                    </td>
                                    <td data-label="Date & Time">
                                        <span
                                            v-html="ticketTimeAndDate(ticket)"
                                        ></span>
                                    </td>
                                    <td data-label="">
                                        <button
                                            type="button"
                                            :style="{
                                                'background-color':
                                                    event.buttoncolour,
                                                'border-color':
                                                    event.buttoncolour,
                                            }"
                                            class="btn btn-secondary btn-sm"
                                            @click="exportCalendar(ticket.id)"
                                        >
                                            <span class="fa fa-calendar"></span>
                                            Add To Calendar
                                        </button>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </div>

                <div class="card-footer hg-blank-footer">
                    <button
                        type="button"
                        :style="{
                            'background-color': event.buttoncolour,
                            'border-color': event.buttoncolour,
                        }"
                        class="btn btn-secondary"
                        @click="exportCalendar()"
                    >
                        <span class="fa fa-calendar"></span> Add All To Calendar
                    </button>
                </div>
            </div>
        </div>

        <div v-if="hasPayments && paidEvent" class="col col-12">
            <div class="card">
                <div
                    class="card-header hg-underline"
                    :style="underlineOverride"
                >
                    Payments Summary
                </div>

                <div class="card-body">
                    <table class="table table-tickets">
                        <thead>
                            <th>Total Amount Paid</th>
                            <th v-if="event_booking.discount_code_id">
                                Discounted By
                            </th>
                            <th v-if="event.fees_pass_on">Total Fees</th>
                            <th v-if="event.show_vat && event.vat_exclusive">
                                Total VAT Amount
                            </th>
                            <th>Payment Date</th>
                            <th>Payment Type</th>
                            <th>Refunded</th>
                        </thead>
                        <tbody>
                            <tr v-for="payment in paymentsMade">
                                <td
                                    data-label="Total amount paid"
                                    id="bstotalamountpaid"
                                    :class="{ refunded: payment.refunded }"
                                >
                                    {{ payment.amount | currency('£') }}
                                </td>
                                <td
                                    data-label="Discounted by"
                                    v-if="event_booking.discount_code_id"
                                >
                                    {{
                                        payment.discount_amount | currency('£')
                                    }}
                                </td>
                                <td
                                    data-label="Total Fees"
                                    v-if="event.fees_pass_on"
                                >
                                    {{ payment.total_fees | currency('£') }}
                                </td>
                                <td
                                    data-label="Total VAT Amount"
                                    v-if="event.vat_exclusive"
                                >
                                    {{
                                        (fees.vat_amount / 100) | currency('£')
                                    }}
                                </td>
                                <td data-label="Payment date">
                                    {{ payment.payment_datetime | formatDate }}
                                </td>
                                <td data-label="Payment" id="bspaymenttype">
                                    {{
                                        payment.payment_type == 'stripe'
                                            ? 'Credit/Debit Card'
                                            : payment.payment_type
                                    }}
                                </td>
                                <td data-label="Refunded" id="bsrefundmade">
                                    {{ payment.refunded ? 'Yes' : 'No' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            v-if="
                (!hasPayments || !paidEvent) &&
                !event_booking.free_booking &&
                hasPaidTickets
            "
            class="col col-12"
        >
            <div class="card">
                <div
                    class="card-header hg-underline"
                    :style="underlineOverride"
                >
                    To Be Paid
                </div>

                <div class="card-body">
                    <table class="table table-tickets">
                        <thead>
                            <th>Total Amount To Pay</th>
                            <th v-if="event_booking.discount_code_id">
                                Discounted By
                            </th>
                            <th v-if="event.fees_pass_on">Total Fees</th>
                            <th v-if="event.show_vat && event.vat_exclusive">
                                Total VAT Amount
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td
                                    data-label="Total amount to pay"
                                    v-if="
                                        event.vat_exclusive &&
                                        event.fees_pass_on
                                    "
                                >
                                    {{
                                        (totalCostForNonCard(
                                            tickets,
                                            event_booking.discount_percentage,
                                            discountValid,
                                            true
                                        ) +
                                            fees.vat_amount / 100 +
                                            fees.standard.total_fees / 100)
                                            | currency('£')
                                    }}
                                </td>
                                <td
                                    data-label="Total amount to pay"
                                    v-if="
                                        !event.vat_exclusive &&
                                        event.fees_pass_on
                                    "
                                >
                                    {{
                                        (totalCostForNonCard(
                                            tickets,
                                            event_booking.discount_percentage,
                                            discountValid,
                                            true
                                        ) +
                                            fees.standard.total_fees / 100)
                                            | currency('£')
                                    }}
                                </td>
                                <td
                                    data-label="Total amount to pay"
                                    v-if="
                                        event.vat_exclusive &&
                                        !event.fees_pass_on
                                    "
                                >
                                    {{
                                        (totalCostForNonCard(
                                            tickets,
                                            event_booking.discount_percentage,
                                            discountValid,
                                            true
                                        ) +
                                            fees.vat_amount / 100)
                                            | currency('£')
                                    }}
                                </td>
                                <td
                                    data-label="Total amount to pay"
                                    v-if="
                                        !event.vat_exclusive &&
                                        !event.fees_pass_on
                                    "
                                >
                                    {{
                                        totalCostForNonCard(
                                            tickets,
                                            event_booking.discount_percentage,
                                            discountValid,
                                            true
                                        ) | currency('£')
                                    }}
                                </td>
                                <td
                                    data-label="Discounted By"
                                    v-if="event_booking.discount_code_id"
                                >
                                    {{ event_booking.discount_percentage }} %
                                </td>
                                <td
                                    data-label="Total Fess"
                                    v-if="event.fees_pass_on"
                                >
                                    {{
                                        (fees.standard.total_fees / 100)
                                            | currency('£')
                                    }}
                                </td>
                                <td
                                    data-label="Total VAT Amount"
                                    v-if="event.vat_exclusive"
                                >
                                    {{
                                        (fees.vat_amount / 100) | currency('£')
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div
            v-if="fees && fees.free_booking && hasPaidTickets"
            class="col col-12"
        >
            <div class="card">
                <div
                    class="card-header hg-underline"
                    :style="underlineOverride"
                >
                    Free Booking
                </div>

                <div class="card-body">
                    The discount code was successful giving you a free booking
                    for this event!
                </div>
            </div>
        </div>

        <div class="col col-12">
            <org-events :event="event"></org-events>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import costCalcs from './../common/cost-calcs';
import orgEventsVue from '../../common/org-events.vue';
import socialCircles from './../common/social-circles.vue';
import { mapGetters } from 'vuex';
import Vue2Filters from 'vue2-filters';

export default {
    components: {
        orgEvents: orgEventsVue,
        'social-circles': socialCircles,
    },

    mixins: [costCalcs, Vue2Filters.mixin],

    beforeRouteLeave(to, from, next) {
        // Prevents going back to payments, need to ensure doesn't break other areas
        next(false);
    },

    data() {
        return {
            event: this.$store.getters.getEvent,
            tickets: this.$store.getters.getSelectedTickets,

            event_booking: this.$store.getters.getEventBooking,
            fees: this.$store.getters.getFees,
            orgWebsite: this.$store.getters.getExtWebsite,

            paymentMethod: 'Card',
            country: 'UK', //Defaults to UK card

            totalVat: 0,
            totalIncFees: 0,
            totalIncFeesInternational: 0,

            //Should be without vat as well
            costNet: 0,
            costNetInternational: 0,

            //TODO needs populating
            vatExclusive: false,

            paymentSubmitted: false,

            paymentsMade: [],

            paymentStatus: null,

            paymentInfo: {
                stripe_enabled: false,
                bacs: false,
                cheque: false,
            },
        };
    },

    created() {
        if (this.event_booking.payment_status == 'unpaid') {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const paymentIntent = urlParams.get('payment_intent');

            if (paymentIntent) {
                this.$http
                    .put(
                        '/event_bookings/' +
                            this.event_booking.uuid +
                            '/finish_booking' +
                            '.json',
                        { payment_intent_id: paymentIntent }
                    )
                    .then((response) => {
                        this.event_booking.payment_status = 'paid';
                        this.$store.commit(
                            'setEventBooking',
                            this.eventBooking
                        );
                        this.getPaymentsMade();
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                this.getPaymentsMade();
            }
        } else {
            this.getPaymentsMade();
        }
    },

    computed: {
        ...mapGetters({
            hasPaidTickets: 'getChargeable',
        }),
        showVatInTitle() {
            if (this.event.show_vat) {
                return (
                    '(' + (this.event.vat_exclusive ? 'exc' : 'inc') + ' VAT)'
                );
            } else {
                return '';
            }
        },

        paidEvent() {
            if (
                this.paymentStatus == 'unpaid' ||
                this.paymentStatus == 'refunded'
            ) {
                return false;
            } else {
                return true;
            }
        },

        underlineOverride() {
            return {
                borderBottom: '4px solid' + this.event.phcolour,
            };
        },

        actualCostBG() {
            return { backgroundColor: this.event.phcolour };
        },

        iconColor() {
            return {
                color: this.event.phcolour,
            };
        },

        hasPayments() {
            return this.paymentsMade.length > 0;
        },

        discountValid() {
            if (this.event && this.event.datetime_eb) {
                return moment(this.event.datetime_eb).isAfter(new Date());
            }
            return false;
        },

        refundable() {
            var status = this.event_booking.payment_status;
            if (status == 'paid' || status == 'part_paid') {
                return true;
            }
            return false;
        },
    },

    methods: {
        getPaymentsMade() {
            // TODO return with the first call
            var urlWithID =
                '/payments/' + this.event_booking.uuid + '/get_payments/';
            this.$http
                .get(urlWithID)
                .then((response) => {
                    this.paymentsMade = response.data.payments;

                    if (swal) {
                        try {
                            swal.hideLoading();
                            swal.clickConfirm();
                        } catch (err) {
                            // Swallow errors from the click
                        }
                    }

                    // TODO is this duplicated?
                    this.paymentStatus = response.data.payment_status;
                })
                .catch((e) => {
                    alert('Error getting payments');
                });
        },

        discountTicketText(ticket) {
            if (ticket.discount_code_id) {
                if (ticket.discount_type == 'percentage') {
                    return 'Discount: ( ' + ticket.discount_amount + '% )';
                } else {
                    return 'Discount: ( £' + ticket.discount_amount + ' )';
                }
            } else {
                return '';
            }
        },

        ticketHeaderName(ticket) {
            var groupDesc = null;
            if (this.event.ticket_groups) {
                // forEach won't return or break
                for (var i = 0; i < this.event.ticket_groups.length; i++) {
                    var tg = this.event.ticket_groups[i];
                    if (tg.id == ticket.ticket_group_id) {
                        groupDesc = tg.description;
                        break;
                    }
                }
            }
            return groupDesc;
        },

        ticketTimeAndDate(ticket) {
            var startTime = null;
            var endTime = null;

            if (ticket.start_time) {
                var sdt = new Date(ticket.start_time);
                startTime = moment(sdt).format('DD/MM/YYYY HH:mm A');
            }

            if (ticket.end_time) {
                var edt = new Date(ticket.end_time);
                endTime = moment(edt).format('DD/MM/YYYY HH:mm A');
            }

            if (startTime && endTime) {
                return `${startTime} <br/> ${endTime}`;
            } else if (startTime && !endTime) {
                return startTime;
            } else {
                return '';
            }
        },

        exportCalendar(ticket_id = null) {
            var self = this;
            self.$swal({
                title: 'Would you like to download details of your event?',
                text: '.ics files can be imported into your calendar.',
                allowEnterKey: false,
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes!',
                closeOnConfirm: true,
            }).then(function (result) {
                if (result.value) {
                    let config = {
                        responseType: 'blob',
                    };
                    self.$http
                        .post(
                            `/ics_export/${self.event_booking.uuid}`,
                            { ticket_id: ticket_id },
                            config
                        )
                        .then(
                            function (response) {
                                self.forceFileDownload(response);
                            },
                            function (error) {
                                self.$notify.error({
                                    title: 'Error',
                                    message: 'Problem downloading ics file',
                                });
                            }
                        );
                }
            });
        },

        forceFileDownload(response) {
            console.log(response);
            const url = window.URL.createObjectURL(
                new Blob([response.data], { type: 'text/calendar' })
            );
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${this.event.title}.ics`);
            document.body.appendChild(link);
            link.click();
        },

        cancelBooking() {
            var self = this;
            var title = 'Are you sure?';
            var text = 'This will cancel the booking!';

            var uuid = this.event_booking.uuid;

            self.$swal({
                title: title,
                text: text,
                // type: "warning",
                showCancelButton: true,
                allowEnterKey: false,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: 'Yes, Cancel Booking!',
                closeOnConfirm: true,
            }).then(function () {
                self.$http.put('/event_bookings/' + uuid + '/cancel').then(
                    function () {
                        //Do a redirect somewhere
                        //TODO we need a cancellation screen
                        self.event_booking.booking_count = 0;
                        self.event_booking.cancelled_at = Date.now();
                        self.$notify.success({
                            message: 'The booking has been cancelled',
                            title: 'Success',
                        });
                    },
                    function () {
                        self.$notify.error({
                            message: 'The booking has not been cancelled',
                            title: 'Error',
                        });
                    }
                );
            });
        },
    },
};
</script>

<style>
.no-border {
    border-style: none;
}

.icon-styling {
    float: right;
    padding-top: 5px;
    font-size: large;
}
</style>
